import React, { useEffect, useState, useContext, useMemo } from 'react';
import { useLocation } from 'react-router-dom';
import { getkyc, updatekycStatus } from '../../../API/Api';
import _IndividualDetails from './_IndividualDetails';
import _EntityDetails from './_EntityDetails';
import _EntityDetails_Law from './_EntityDetails_Law';
import _RiskAssessment_MAS from './_RiskAssessment_MAS';
import _RiskAssessment_MAS_AML from './riskAssessment_MAS_AML/_RiskAssessment_MAS_AML';
import _RiskAssessment_LAW_AML from './riskAssessment_LAW_AML/_RiskAssessment_LAW_AML';
import _RiskAssessment_ACRA from './_RiskAssessment_ACRA';
import _RiskAssessment_ACRA_AML from './riskAssessment_ACRA_AML/_RiskAssessment_ACRA_AML';
import _RiskAssessment_Law from './_RiskAssessment_Law';
import PageNotFound from '../../../PageNotFound';
import OnGoingMonitoring from './OnGoingMonitoring';
import OnGoingMonitoring_Law from './OnGoingMonitoring_Law';
import OnGoingMonitoring_LAW_AML from './riskAssessment_LAW_AML/OnGoingMonitoring_LAW_AML';
import FormSteps from './FormSteps';
import FormHeader from './FormHeader';
import { ToastContainer } from 'react-toastify';
import { jwtDecode } from 'jwt-decode';
import { TokenContext } from '../../../App';
import { useNavigate } from 'react-router-dom';
import FormSteps_Law from './FormSteps_Law';
import _KycVideoForm_Law from './_KycVideoForm_Law';
import OnGoingMonitoring_MAS_AML from './riskAssessment_MAS_AML/OnGoingMonitoring_MAS_AML';

const __KycAmlForm = () => {
  const [encodedAccessToken] = useContext(TokenContext);
  const location = useLocation();

  // 使用 useMemo 缓存查询参数，避免每次渲染都创建新对象
  const queryParams = useMemo(() => new URLSearchParams(location.search), [location.search]);
  const currentUrl = location.pathname;
  const token = encodedAccessToken || queryParams.get('formToken');
  const clientFormId = queryParams.get('clientFormId');
  const currentPage = queryParams.get('page');

  // 使用 useMemo 缓存 decodedToken，避免每次渲染都创建新对象
  const decodedToken = useMemo(() => {
    if (!token) return {};
    try {
      return jwtDecode(token);
    } catch (e) {
      console.error('Failed to decode token:', e);
      return {};
    }
  }, [token]);

  const navigate = useNavigate();
  const companyId = decodedToken?.companyId;

  const [clientData, setclientData] = useState({ name: '', type: '', formStatus: '', maxPage: '3' }); // maxPage 3 initial value to not show 'please complete previous steps' duirng inital load
  const [formCurrentPage, setformCurrentPage] = useState(currentPage); // not in use?
  // const [readOnlyTwo, setReadOnlyTwo] = useState(false);

  useEffect(() => {
    if (!clientFormId || !token) return;

    const fetchData = async () => {
      const kycData = await getkyc(clientFormId, token);

      // 使用函数式更新，避免不必要的重新渲染
      setclientData(prevData => {
        // 如果数据没有实质性变化，返回原对象，避免重新渲染
        if (
          prevData._id === kycData.data?._id &&
          prevData.maxPage === kycData.data?.maxPage &&
          prevData.formStatus === kycData.data?.formStatus
        ) {
          return prevData;
        }
        return kycData.data;
      });
    };
    fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [clientFormId, token, currentPage]);

  let showSubmitButton = true;
  let readOnlyOne = false;
  let readOnlyTwo = false;
  if (clientData.maxPage > 1 || decodedToken.role == 'viewer') {
    // readOnlyOne=true
    showSubmitButton = false;
  }
  let number = 2;
  if (clientData.formAuthority === 'Law' && clientData?.details?.isvVideo === 'yes') {
    number = 3;
    console.log(number);
  }
  if (clientData.maxPage > number || decodedToken.role == 'viewer' || clientData.archived) {
    readOnlyOne = true;
    readOnlyTwo = true;
  }
  if (currentUrl === '/form/kyc-aml' && decodedToken.role != 'viewer' && !clientData.archived) {
    readOnlyOne = false;
  }

  const handleRedoAssessment = async () => {
    const redoStatus = 'pending_risk_assessment';
    const redoMaxPage = 2;
    const redoNextRescreeningDate = '-';
    const redoOngoingMonitoring = false;

    await updatekycStatus({
      formStatus: redoStatus,
      id: clientFormId,
      nextRescreeningDate: redoNextRescreeningDate,
      onGoingMonitoring: redoOngoingMonitoring,
      maxPage: redoMaxPage,
    });

    setclientData({
      ...clientData,
      formStatus: redoStatus,
      maxPage: redoMaxPage,
    });
    navigate(`/kyc-aml/form?clientFormId=${clientFormId}&page=${redoMaxPage}`);
  };

  // const onSetReadOnlyTwo = async (readOnlyFlg) => {
  //   setReadOnlyTwo(readOnlyFlg);
  // }

  if (!clientData) {
    return <PageNotFound />;
  }

  // This is External link for Page 1
  if (currentUrl === '/form/kyc-aml') {
    // check (!decodedToken?.email), if want to know its formToken or userToken
    return (
      <div className='flex flex-col items-center justify-center min-h-screen w-full bg-slate-300 absolute top-0 left-0 right-0 z-50'>
        <ToastContainer pauseOnHover={false} pauseOnFocusLoss={false} limit={3} autoClose={2750} />
        {clientData.type === 'individual' && (
          <_IndividualDetails
            token={token}
            showSubmitButton={showSubmitButton}
            currentUrl={currentUrl}
            individualName={clientData.name}
            clientFormId={clientFormId}
            companyId={companyId}
            readOnly={readOnlyOne}
            maxPage={clientData.maxPage}
          />
        )}
        {clientData.type === 'entity' && clientData.formAuthority !== 'Law' && (
          <_EntityDetails
            token={token}
            showSubmitButton={showSubmitButton}
            currentUrl={currentUrl}
            companyName={clientData.name}
            clientFormId={clientFormId}
            companyId={companyId}
            readOnly={readOnlyOne}
            maxPage={clientData.maxPage}
          />
        )}
        {clientData.type === 'entity' && clientData.formAuthority === 'Law' && (
          <_EntityDetails_Law
            token={token}
            showSubmitButton={showSubmitButton}
            currentUrl={currentUrl}
            companyName={clientData.name}
            clientFormId={clientFormId}
            companyId={companyId}
            readOnly={readOnlyOne}
            maxPage={clientData.maxPage}
          />
        )}
      </div>
    );
  }
  if (clientData.formAuthority != 'Law' || !clientData?.details?.isvVideo || clientData?.details?.isvVideo === 'no') {
    // This is Internal link for Page 1
    if (currentPage == 1 && clientData.maxPage >= 1) {
      return (
        <>
          <FormHeader clientData={clientData} />
          <FormSteps />
          {clientData.type === 'individual' && (
            <_IndividualDetails
              token={token}
              showSubmitButton={showSubmitButton}
              currentUrl={currentUrl}
              individualName={clientData.name}
              clientFormId={clientFormId}
              readOnly={readOnlyOne}
              formAuthority={clientData.formAuthority}
            />
          )}
          {clientData.type === 'entity' && clientData.formAuthority !== 'Law' && (
            <_EntityDetails
              token={token}
              showSubmitButton={showSubmitButton}
              currentUrl={currentUrl}
              companyName={clientData.name}
              clientFormId={clientFormId}
              readOnly={readOnlyOne}
              formAuthority={clientData.formAuthority}
            />
          )}
          {clientData.type === 'entity' && clientData.formAuthority === 'Law' && (
            <_EntityDetails_Law
              token={token}
              showSubmitButton={showSubmitButton}
              currentUrl={currentUrl}
              companyName={clientData.name}
              clientFormId={clientFormId}
              readOnly={readOnlyOne}
              formAuthority={clientData.formAuthority}
            />
          )}
        </>
      );

      // Only Page 2 has ACRA vs MAS form difference
    } else if (
      currentPage == 2 &&
      clientData.maxPage >= 2 &&
      clientData.formAuthority === 'MAS' &&
      decodedToken.kycSettings?.apiType === 'sanctions'
    ) {
      return (
        <>
          <FormHeader clientData={clientData} />
          <FormSteps />
          <_RiskAssessment_MAS
            currentUrl={currentUrl}
            clientFormId={clientFormId}
            userType={clientData.type}
            readOnly={readOnlyTwo}
            formAuthority={clientData.formAuthority}
          />
        </>
      );
    } else if (
      currentPage == 2 &&
      clientData.maxPage >= 2 &&
      clientData.formAuthority === 'MAS' &&
      decodedToken.kycSettings?.apiType === 'amlwatcher'
    ) {
      return (
        <>
          <FormHeader clientData={clientData} />
          <FormSteps />
          <_RiskAssessment_MAS_AML
            currentUrl={currentUrl}
            clientFormId={clientFormId}
            userType={clientData.type}
            readOnly={readOnlyTwo}
            formAuthority={clientData.formAuthority}
          />
        </>
      );
    } else if (
      currentPage == 2 &&
      clientData.maxPage >= 2 &&
      clientData.formAuthority === 'ACRA' &&
      decodedToken.kycSettings?.apiType === 'amlwatcher'
    ) {
      return (
        <>
          <FormHeader clientData={clientData} />
          <FormSteps />
          <_RiskAssessment_ACRA_AML
            currentUrl={currentUrl}
            clientFormId={clientFormId}
            userType={clientData.type}
            readOnly={readOnlyTwo}
            formAuthority={clientData.formAuthority}
          />
        </>
      );
    } else if (currentPage == 2 && clientData.maxPage >= 2 && clientData.formAuthority === 'ACRA') {
      return (
        <>
          <FormHeader clientData={clientData} />
          <FormSteps />
          <_RiskAssessment_ACRA
            currentUrl={currentUrl}
            clientFormId={clientFormId}
            userType={clientData.type}
            readOnly={readOnlyTwo}
            formAuthority={clientData.formAuthority}
          />
        </>
      );
    } else if (
      currentPage == 2 &&
      clientData.maxPage >= 2 &&
      clientData.formAuthority === 'Law' &&
      decodedToken.kycSettings?.apiType === 'sanctions'
    ) {
      return (
        <>
          <FormHeader clientData={clientData} />
          <FormSteps />
          <_RiskAssessment_Law
            currentUrl={currentUrl}
            clientFormId={clientFormId}
            userType={clientData.type}
            readOnly={readOnlyTwo}
            formAuthority={clientData.formAuthority}
          />
          {/* onSetReadOnly={onSetReadOnlyTwo}  */}
        </>
      );
    } else if (
      currentPage == 2 &&
      clientData.maxPage >= 2 &&
      clientData.formAuthority === 'Law' &&
      decodedToken.kycSettings?.apiType === 'amlwatcher'
    ) {
      return (
        <>
          <FormHeader clientData={clientData} />
          <FormSteps />
          <_RiskAssessment_LAW_AML
            currentUrl={currentUrl}
            clientFormId={clientFormId}
            userType={clientData.type}
            readOnly={readOnlyTwo}
            formAuthority={clientData.formAuthority}
          />
          {/* onSetReadOnly={onSetReadOnlyTwo}  */}
        </>
      );
    } else if (currentPage == 2 && clientData.maxPage >= 2 && clientData.formAuthority === 'MAS') {
      // 兜底条件：处理MAS表单的其他情况（apiType不是sanctions或amlwatcher）
      return (
        <>
          <FormHeader clientData={clientData} />
          <FormSteps />
          <_RiskAssessment_MAS
            currentUrl={currentUrl}
            clientFormId={clientFormId}
            userType={clientData.type}
            readOnly={readOnlyTwo}
            formAuthority={clientData.formAuthority}
          />
        </>
      );

      // Page 3 is same for all
    } else if (currentPage == 2 && clientData.maxPage >= 2 && clientData.formAuthority === 'Law') {
      // 兜底条件：处理MAS表单的其他情况（apiType不是sanctions或amlwatcher）
      return (
        <>
          <FormHeader clientData={clientData} />
          <FormSteps />
          <_RiskAssessment_Law
            currentUrl={currentUrl}
            clientFormId={clientFormId}
            userType={clientData.type}
            readOnly={readOnlyTwo}
            formAuthority={clientData.formAuthority}
          />
        </>
      );

      // Page 3 is same for all
    } else if (currentPage == 3 && clientData.maxPage >= 3) {
      if (clientData.formAuthority === 'MAS' && decodedToken.kycSettings?.apiType === 'amlwatcher') {
        return (
          <>
            <FormHeader clientData={clientData} />
            <FormSteps />
            <OnGoingMonitoring_MAS_AML
              currentUrl={currentUrl}
              clientFormId={clientFormId}
              userType={clientData.type}
              formAuthority={clientData.formAuthority}
            />
          </>
        );
      } else if (clientData.formAuthority === 'ACRA' && decodedToken.kycSettings?.apiType === 'amlwatcher') {
        return (
          <>
            <FormHeader clientData={clientData} />
            <FormSteps />
            <OnGoingMonitoring_MAS_AML
              currentUrl={currentUrl}
              clientFormId={clientFormId}
              userType={clientData.type}
              formAuthority={clientData.formAuthority}
            />
          </>
        );
      } else if (clientData.formAuthority === 'Law' && decodedToken.kycSettings?.apiType === 'amlwatcher') {
        return (
          <>
            <FormHeader clientData={clientData} />
            <FormSteps />
            <OnGoingMonitoring_MAS_AML
              currentUrl={currentUrl}
              clientFormId={clientFormId}
              userType={clientData.type}
              formAuthority={clientData.formAuthority}
            />
          </>
        );
      } else {
        return (
          <>
            <FormHeader clientData={clientData} />
            <FormSteps />
            {clientData.formAuthority === 'Law' ? (
              <OnGoingMonitoring_Law
                currentUrl={currentUrl}
                clientFormId={clientFormId}
                userType={clientData.type}
                formAuthority={clientData.formAuthority}
              />
            ) : (
              <OnGoingMonitoring
                currentUrl={currentUrl}
                clientFormId={clientFormId}
                userType={clientData.type}
                formAuthority={clientData.formAuthority}
              />
            )}
          </>
        );
      }
    } else {
      return (
        <>
          <FormHeader clientData={clientData} />
          <FormSteps />
          <div> Please complete previous form steps! </div>
        </>
      );
    }
  } else {
    // This is Internal link for Page 1
    if (currentPage == 1 && clientData.maxPage >= 1) {
      return (
        <>
          <FormHeader clientData={clientData} />
          <FormSteps_Law />
          {clientData.type === 'individual' && (
            <_IndividualDetails
              token={token}
              showSubmitButton={showSubmitButton}
              currentUrl={currentUrl}
              individualName={clientData.name}
              clientFormId={clientFormId}
              readOnly={readOnlyOne}
              formAuthority={clientData.formAuthority}
            />
          )}
          {clientData.type === 'entity' && clientData.formAuthority !== 'Law' && (
            <_EntityDetails
              token={token}
              showSubmitButton={showSubmitButton}
              currentUrl={currentUrl}
              companyName={clientData.name}
              clientFormId={clientFormId}
              readOnly={readOnlyOne}
              formAuthority={clientData.formAuthority}
            />
          )}
          {clientData.type === 'entity' && clientData.formAuthority === 'Law' && (
            <_EntityDetails_Law
              token={token}
              showSubmitButton={showSubmitButton}
              currentUrl={currentUrl}
              companyName={clientData.name}
              clientFormId={clientFormId}
              readOnly={readOnlyOne}
              formAuthority={clientData.formAuthority}
            />
          )}
        </>
      );

      // Only Page 2 has ACRA vs MAS form difference
    } else if (currentPage == 2 && clientData.maxPage >= 2) {
      return (
        <>
          <FormHeader clientData={clientData} />
          <FormSteps_Law />
          <_KycVideoForm_Law
            currentUrl={currentUrl}
            clientFormId={clientFormId}
            userType={clientData.type}
            readOnly={readOnlyTwo}
            formAuthority={clientData.formAuthority}
          />
        </>
      );
    } else if (currentPage == 3 && clientData.maxPage >= 3 && clientData.formAuthority === 'MAS') {
      return (
        <>
          <FormHeader clientData={clientData} />
          <FormSteps />
          <_RiskAssessment_MAS
            currentUrl={currentUrl}
            clientFormId={clientFormId}
            userType={clientData.type}
            readOnly={readOnlyTwo}
            formAuthority={clientData.formAuthority}
          />
        </>
      );
    } else if (
      currentPage == 3 &&
      clientData.maxPage >= 3 &&
      clientData.formAuthority === 'ACRA' &&
      decodedToken.kycSettings?.apiType === 'amlwatcher'
    ) {
      return (
        <>
          <FormHeader clientData={clientData} />
          <FormSteps />
          <_RiskAssessment_ACRA_AML
            currentUrl={currentUrl}
            clientFormId={clientFormId}
            userType={clientData.type}
            readOnly={readOnlyTwo}
            formAuthority={clientData.formAuthority}
          />
        </>
      );
    } else if (currentPage == 3 && clientData.maxPage >= 3 && clientData.formAuthority === 'ACRA') {
      return (
        <>
          <FormHeader clientData={clientData} />
          <FormSteps />
          <_RiskAssessment_ACRA
            currentUrl={currentUrl}
            clientFormId={clientFormId}
            userType={clientData.type}
            readOnly={readOnlyTwo}
            formAuthority={clientData.formAuthority}
          />
        </>
      );
    } else if (currentPage == 3 && clientData.maxPage >= 3 && clientData.formAuthority === 'Law') {
      return (
        <>
          <FormHeader clientData={clientData} />
          <FormSteps_Law />
          <_RiskAssessment_Law
            currentUrl={currentUrl}
            clientFormId={clientFormId}
            userType={clientData.type}
            readOnly={readOnlyTwo}
            formAuthority={clientData.formAuthority}
          />
        </>
      );

      // Page 3 is same for all
    } else if (currentPage == 4 && clientData.maxPage >= 4) {
      return (
        <>
          <FormHeader clientData={clientData} />
          <FormSteps_Law />
          {clientData.formAuthority === 'Law' ? (
            <OnGoingMonitoring_Law
              currentUrl={currentUrl}
              clientFormId={clientFormId}
              userType={clientData.type}
              formAuthority={clientData.formAuthority}
            />
          ) : (
            <OnGoingMonitoring
              currentUrl={currentUrl}
              clientFormId={clientFormId}
              userType={clientData.type}
              formAuthority={clientData.formAuthority}
            />
          )}
        </>
      );
    } else {
      return (
        <>
          <FormHeader clientData={clientData} />
          <FormSteps_Law />
          <div> Please complete previous form steps! </div>
        </>
      );
    }
  }
};

export default __KycAmlForm;
